<template>
  <div class="c-record-kpi">
    <!-- filter -->
    <record-kpi-filter
      :medias="dropMedias"
      :games="gameData"
      @on-down="downExcel"
      @on-import="importExcel"
      @on-set="addRecord"
      @on-change="filterData"
      @on-search="searchFilterData"
    />
    <!-- table -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight" v-loading="loading">
        <record-kpi-table
          :height="tableHeight"
          :data="tableList"
          :columns="tableCol"
          @on-edit="addRecord"
          @on-del="delRecord"
          @on-refresh="getData"
        />

        <el-pagination
          :total="total"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          :page-sizes="[10, 20, 30, 40, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="changePageIndex"
          @size-change="changePageSize"
          class="c-table-page pager"
          background
        />
      </Viewport>
    </div>
    <!-- 弹出框 -->
    <set-record
      v-model="model"
      title="绩效KPI"
      :loading="loading"
      :medias="dropMedias"
      :edit="edit"
      :info="info"
      :games="gameData"
      @on-save="saveRecord"
    />

    <resulter
      v-model="resultModel"
      type="KPI数据"
      :add-total="added"
      :update-total="updated"
      :fail-total="failure"
      :req="req_id"
      @on-close="resultOk"
      @on-down="downFailExecl"
    />
  </div>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/record_kpi_column'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, isEmpty } from '@/common/js/utils'
import { HOST_API } from '@/api/config'
import { getSysMedia } from '@/api/common.model'
import { getPtomGroupGames } from '@/api/material.model'
import { getGZRecordKpi, setGZRecordKpi, delGZRecordKpi, getGZRecordKpiList, importKpiExcel } from '@/api/manage.model'
import RecordKpiFilter from './components/record-kpi-filter.vue'
import RecordKpiTable from './components/record-kpi-table'
import SetRecord from './components/set-record'
import Resulter from './components/result-dialog'

export default {
  name: 'recordKpi',
  mixins: [mixin],
  components: { RecordKpiFilter, RecordKpiTable, SetRecord, Resulter },
  methods: {
    getData(filter) {
      let params = {
        page_id: this.pageIndex,
        page_size: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      // 加载状态
      this.loading = true
      getGZRecordKpiList(params)
        .then((data) => {
          this.loading = false
          if (data) {
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              this.total = total_number || 0
              this.tableList = list.map((ret) => {
                // ret.sevenDayKpi = ret.sevenDayKpi.toFixed(2)
                return ret
              })
            }
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    setLocalPage(size) {
      setLocal('RECORD_KPI_PAGESIZE', size)
    },
    addRecord(edit) {
      this.edit = !!edit
      if (edit) {
        const { reportMonth, gameId, mediaId } = edit
        this.loading = true
        getGZRecordKpi({
          reportMonth: reportMonth,
          gameId,
          mediaId
        }).then((data) => {
          this.loading = false
          if (data) {
            const { gameId, mediaId, reportMonth, isSpecial, roi1, roi2, roi3, roi4, roi5 } = data
            this.info = {
              gameId,
              mediaId,
              month: reportMonth,
              isSpecial,
              roi1,
              roi2,
              roi3,
              roi4,
              roi5
            }
            this.model = true
          }
        })
      } else {
        this.info = Object.assign(this.info, {
          gameId: '',
          month: '',
          mediaId: '',
          isSpecial: 2,
          roi1: '',
          roi2: '',
          roi3: '',
          roi4: '',
          roi5: ''
          // roiList: [{roi1: ''}, {roi1: ''}, {roi1: ''}, {roi1: ''}, {roi1: ''}]
        })
        this.model = true
      }
    },
    saveRecord(params) {
      const { gameId, month, mediaId, isSpecial, roi1, roi2, roi3, roi4, roi5 } = params
      const { err, msg } = this.vaild({ gameId, month, mediaId, isSpecial, roi1, roi2, roi3, roi4, roi5 })
      if (err) {
        this.$Message.error({
          duration: 5,
          content: msg
        })
        return
      }
      const roiStr = roi1 + ',' + roi2 + ',' + roi3 + ',' + roi4 + ',' + roi5
      this.loading = true
      setGZRecordKpi({
        reportMonth: month,
        gameId,
        mediaId,
        isSpecial,
        roiStr
      }).then((data) => {
        this.loading = false
        if (data) {
          !this.edit && (this.pageIndex = 1)
          this.getData()
          this.model = false
        }
      })
    },
    delRecord(row) {
      const { reportMonth, gameId, mediaId } = row
      delGZRecordKpi({
        reportMonth,
        gameId,
        mediaId
      }).then((data) => {
        if (data) {
          this.getData()
        }
      })
    },
    vaild(params) {
      const keys = Object.keys(params)
      const value = {
        gameId: '游戏',
        month: '月份',
        roi1: '30日KPI',
        roi2: '30日KPI',
        roi3: '30日KPI',
        roi4: '30日KPI',
        roi5: '30日KPI',
        mediaId: '媒体'
      }
      let err = false
      let msg = ''
      keys.some((ret) => {
        if (isEmpty(params[ret])) {
          msg = `${value[ret]}不能为空`
          err = true
          return false
        } else if (ret.includes('roi') && !params[ret]) {
          msg = '30日KPI需输入0.01-100的数值'
          err = true
          return false
        } else if (params.roi1 >= params.roi2 || params.roi2 >= params.roi3 || params.roi3 >= params.roi4 || params.roi4 >= params.roi5) {
          msg = '30日KPI【ROI1 ~ ROI5】需从小到大输入'
          err = true
          return false
        }
      })
      return { err, msg }
    },
    downExcel() {
      window.open(`${HOST_API}/api/ptom/template/downTemplate?templateType=template_guangz_kpi`, '_blank')
    },
    downFailExecl(req) {
      window.open(`${HOST_API}/api/ptom/guangzKpiSet/downloadImportResult?requestId=${req}`)
    },
    importExcel(file) {
      this.$Spin.show()
      importKpiExcel({ file }).then((data) => {
        this.$Spin.hide()
        if (data) {
          this.resultModel = true
          this.added = data.addTotal
          this.failure = data.failTotal
          this.updated = data.updateTotal
          this.req_id = data.requestId
        }
      })
    },
    preLoadData() {
      Promise.all([getSysMedia(), getPtomGroupGames()])
        .then((data) => {
          const [medias, groups] = data
          if (isArray(medias)) {
            this.dropMedias = medias.map((ret) => {
              return {
                id: ret.mediaId,
                name: ret.mediaName
              }
            })
          }
          if (isArray(groups)) {
            this.gameData = groups.map((ret) => {
              return {
                id: ret.groupId,
                name: ret.groupName
              }
            })
          }
          this.getData({})
        })
        .catch((error) => {
          this.$Message.error({
            duration: 5,
            content: error
          })
        })
    },
    resultOk() {
      this.resultModel = false
      this.getData()
    }
  },
  data() {
    return {
      tableHeight: 330,
      model: null,
      loading: null,
      info: {},
      edit: null,
      gameData: [],

      resultModel: null,
      added: 0,
      failure: 0,
      updated: 0,
      req_id: '',

      dropMedias: []
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('RECORD_KPI_PAGESIZE')) || 20
    this.tableCol = columns
    this.preLoadData()
  }
}
</script>
<style lang="scss" scoped>
.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
